import {FC} from 'react'
import {ProductThumb} from '../../../components/common/ProductThumb'
import {useIntl} from 'react-intl'
import {IInTransitReportModel} from '../core/_models'
import {storeCurrencyLabel} from '../../common/currencyLabel'

type IProps = {
    item: IInTransitReportModel,
    showDetails: (params?: IInTransitReportModel) => void
}

const InTransitReportsTableRow: FC<IProps> = ({item, showDetails}) => {
    const {formatMessage} = useIntl()

    return (
        <tr>
            <th>
                <ProductThumb src={item.image} className='table-img' alt='Product'/>
            </th>
            <td>{item.barcode}</td>
            <td>{item.model}</td>
            <td>{item.name}</td>
            <td>{item.adjusted_quantity}</td>
            <td style={{color: 'green'}}>{item.average_sale_price}{storeCurrencyLabel(formatMessage)}</td>
            <td style={{color: 'green'}}>{item.total_sale_price}{storeCurrencyLabel(formatMessage)}</td>
            <td style={{color: 'green'}}>{item.dumyah_fees}{storeCurrencyLabel(formatMessage)}</td>
            <td style={{color: 'green'}}>{item.net}{storeCurrencyLabel(formatMessage)}</td>
        </tr>
    )
}

export default InTransitReportsTableRow
